module.exports = __webpack_public_path__ + "img/mesa_l001f.c0733ed7.png";